var render = function render(){var _vm=this,_c=_vm._self._c;return _c('templateBase',{attrs:{"module-name":"Relatórios","title":_vm.pageInfos.title,"subtitle":_vm.pageInfos.subtitle},scopedSlots:_vm._u([{key:"sidebar-left",fn:function(){return [_c('side-menu')]},proxy:true},{key:"page",fn:function(){return [_c('router-view')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }